import { internalMessageBus } from "sb-internal-msg-bus";
import { Clock, MessageSender, MessageBus, State, ToggleTabEvent } from "../../../common";
import { datesQueryFactory } from "../queries";
import { DatesRetriever, DatesGateway } from "../retriever";
import { DatesParser } from "../parser";
import { GroupedSportsToDatesMapper } from "../mapper";
export const datesRetrieverFactory = (cms, dict, timeZoneObservable, connections) => {
    const clock = new Clock(Date);
    const datesGateway = new DatesGateway(connections, datesQueryFactory, new GroupedSportsToDatesMapper(dict), clock, cms.timeRange);
    const toggleTabEvent = new ToggleTabEvent(new MessageBus(internalMessageBus), cms.blockId);
    return new DatesRetriever(datesGateway, toggleTabEvent, clock, timeZoneObservable, cms.keepSelectedDay);
};
export const datesParserFactory = (cms, retriever) => {
    const messageSender = new MessageSender(new MessageBus(internalMessageBus), cms.blockId);
    return new DatesParser(retriever, messageSender);
};
export const datesStateFactory = (cms, domId) => {
    const messageSender = new MessageSender(new MessageBus(internalMessageBus), cms.blockId);
    return new State(messageSender, cms.blockId, domId);
};
//# sourceMappingURL=factories.js.map